import type { ToolMark } from './schema'

const mark = (name: string, file: string): ToolMark => ({ name, logo: `/images/tools/${file}` })

/**
 * Every tool logo the site can show. Pages reference these, never a raw path.
 */
export const tools = {
  n8n: mark('n8n', 'n8n.svg'),
  zapier: mark('Zapier', 'zapier.svg'),
  make: mark('Make.com', 'make.svg'),
  openai: mark('OpenAI', 'openai.svg'),
  claude: mark('Claude', 'claude.svg'),
  gemini: mark('Gemini', 'gemini.svg'),
  vapi: mark('Vapi', 'vapi.svg'),
  elevenlabs: mark('ElevenLabs', 'elevenlabs.svg'),
  asana: mark('Asana', 'asana.svg'),
  slack: mark('Slack', 'slack.svg'),
  airtable: mark('Airtable', 'airtable.svg'),
  gohighlevel: mark('GoHighLevel', 'gohighlevel.svg'),
} satisfies Record<string, ToolMark>

/** The daily drivers, in the order you want them shown. */
export const dailyTools: ToolMark[] = [
  tools.n8n,
  tools.zapier,
  tools.make,
  tools.openai,
  tools.claude,
  tools.gemini,
  tools.vapi,
  tools.elevenlabs,
  tools.gohighlevel,
  tools.asana,
  tools.slack,
  tools.airtable,
]
